export default "__VITE_ASSET__DUmkqJyY__"